module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_title-be909cef124d7c604710d6e05027074c.webp";